import env from "react-dotenv";
import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

export default {
    'api1': {
        onLoad: true,
        action: (lang, match, query) => {
            console.log(query, 1211)
            const params = new URLSearchParams({
                page: query.page,
                entries: query.entries,
                filter: query.filter || '',
                sortType: query.sortType ?? -1,
                sortField: query.sortField ?? '_id',
            });
            return fetch(`${API_ENDPOINT}/shopify/payout-transactions?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300)
                    return {
                        items: result.items,
                        total: result.total,
                    }
            })
        }
    },
    'sync-transactions': {
        onLoad: false,
        action: (data) => {
            const { customerId } = data;
            return fetch(API_ENDPOINT + `/shopify/payout-reconcile/run`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },
}